import { Bill } from "../objects/bill";
import { PurchasesReceipt } from "../objects/purchasesReceipt";

export const initialisePurchaseForecast = (forecast: PurchasesReceipt): PurchasesReceipt => ({
    ...forecast,
    product_start_date: forecast.product_start_date ? new Date(forecast.product_start_date) : null,
    product_booking_date: forecast.product_booking_date ? new Date(forecast.product_booking_date) : null,
    payment_limit_date: forecast.payment_limit_date ? new Date(forecast.payment_limit_date) : null
});


export const initialisePurchaseUnpaid = (forecast: Bill): Bill => ({
    ...forecast, due_date: forecast.due_date ? new Date(forecast.due_date) : null,
    invoice_date: forecast.invoice_date ? new Date(forecast.invoice_date) : null,
    product_start_date: forecast.product_start_date ? new Date(forecast.product_start_date) : null
});